export default "__VITE_ASSET__B6F_VFC7__"